import * as z from 'zod/mini';
import { BloodPressure } from '../measurements/BloodPressure.js';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for blood pressure input configuration. The answer value (`{ systolic, diastolic }`) is
 * derived from the {@link BloodPressure} composite measurement definition.
 */
export const BloodPressureInput = defineFormInput({
    type: 'BLOOD_PRESSURE',
    input: {
        question: z.string(),
        help: z.optional(z.string()),
    },
    value: { ...BloodPressure.valueShape },
});
//# sourceMappingURL=BloodPressureInput.js.map